import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Money from '~/components/Money';
import Button from '~/components/ui/Button';
import { InnerCard } from '~/components/ui/Card';
import Dialog from '~/components/ui/Dialog';
import Input from '~/components/ui/Input';
import useBalance from '~/modules/subscription/useBalance';
import useTopUp from '~/modules/subscription/useTopUp';

export default function TopUpDialog() {
  const { t } = useTranslation('', { keyPrefix: 'subscription.topUpDialog' });
  const [amount, setAmount] = useState('');
  const { data: balance } = useBalance();
  const { mutate: topUp, isPending } = useTopUp();

  const handleTopUp = () => {
    const parsedAmount = Number.parseFloat(amount);
    if (!Number.isNaN(parsedAmount) && parsedAmount > 0) {
      topUp(parsedAmount);
    }
  };

  return (
    <Dialog className="sm:max-w-[460px] flex flex-col gap-6">
      <div>
        <h2 className="text-center leading-10">{t('title')}</h2>
        <p className="text-center text-body text-sm">{t('description')}</p>
      </div>
      <Input
        value={amount}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setAmount(e.target.value)}
        endAdornment="USD"
        placeholder={t('amountPlaceholder')}
        className="text-sm"
        label={t('amountLabel')}
      />
      <InnerCard>
        <div className="flex items-center justify-between">
          <p className="text-sm text-body">{t('currentBalance')}</p>
          <Money className="text-sm font-bold" value={balance || 0} />
        </div>
      </InnerCard>
      <Button className="w-full" onClick={handleTopUp} isPending={isPending} isDisabled={!amount}>
        {t('submit')}
      </Button>
    </Dialog>
  );
}
